import type { BaseLocationRadiusConfig } from '../LocationSearch.types';

/**
 * Returns the search radius in miles based on the Radar layer/s.
 * Different location types (street, city, state, etc.) require different search radius.
 *
 * @see https://radar.com/documentation/api#autocomplete
 */
export function getSearchRadiusByPlaceType(
  types: readonly string[] | string[] | undefined,
  radiusConfig: BaseLocationRadiusConfig,
): number {
  const hasNoTypes = !types || types.length === 0;

  // ─────────────────────────────────────────────────────────────────────────────

  if (hasNoTypes) {
    return radiusConfig.SMALL;
  }

  // Very specific locations: addresses, places

  if (types.includes('address') || types.includes('place') || types.includes('fine')) {
    return radiusConfig.SMALLEST;
  }

  // City/neighborhood level: postal codes, neighborhoods

  if (types.includes('postalCode') || types.includes('coarse') || types.includes('neighborhood')) {
    return radiusConfig.SMALL;
  }

  // City level: localities

  if (types.includes('locality')) {
    return radiusConfig.MEDIUM;
  }

  // County level

  if (types.includes('county')) {
    return radiusConfig.LARGE;
  }

  // State/country level

  if (types.includes('state') || types.includes('country')) {
    return radiusConfig.XLARGE;
  }

  // ─────────────────────────────────────────────────────────────────────────────

  return radiusConfig.SMALL;
}
